<template>
    <section>
        <div class="row">
            <div class="col-12 px-0 mb-5">
                <img class="img-fluid w-100" v-bind:src="article.imageUrl" />
            </div>
        </div>
        <div class="row px-5 mt-4">
            <div class="col-lg-9 col-md-8 col-sm-12 content pt-md-5 pb-5 order-md-2">
                <h1 class="text-danger font-weight-bold text-center mb-5 mx-5">
                    {{ article.title }}
                </h1>
                <p class="text-muted text-center font-weight-medium mb-5 mx-5 px-5">
                    {{ article.foreword }}
                </p>
                <div class="row">
                    <div class="col main" v-html="article.content"></div>
                </div>
            </div>
            <div class="col order-md-1">
                <router-link v-if="previousArticle" v-bind:to="{ name: 'article/view', params: {id: previousArticle.id} }" class="d-block">
                    <!-- <img src="@/assets/images/chevron-right.svg" class="arrow mb-4" style="transform: rotate(180deg);" /> -->
                    <h4 class="text-muted">Artikel Sebelumnya</h4>
                    <h4 class="font-weight-medium text-danger">{{ previousArticle.title }}</h4>
                </router-link>
            </div>
            <div class="col text-right order-md-3">
                <router-link v-if="nextArticle" v-bind:to="{ name: 'article/view', params: {id: nextArticle.id} }" class="d-block">
                    <!-- <img src="@/assets/images/chevron-right.svg" class="arrow mb-4" /> -->
                    <h4 class="text-muted">Artikel Sebelumnya</h4>
                    <h4 class="font-weight-medium text-danger">{{ nextArticle.title }}</h4>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ArticleView",
        watch: {
            '$route.params.id'() {
                this.fetchData();
            }
        },
        data: function () {
            return {
                article: {},
                nextArticle: null,
                previousArticle: null
            };
        },
        methods: {
            fetchData() {
                this.axios.get(process.env.API_URL + '/article/' + this.$route.params.id).then(response => {
                    this.article = response.data.data.current;
                    this.previousArticle = response.data.data.prev;
                    this.nextArticle = response.data.data.next;

                    document.title = this.article.title + ' - ' + process.env.APP_NAME;
                });
            }
        },
        created() {
            this.fetchData();
        }
    };
</script>

<style scoped>
    .content >>> p { line-height: 1.7rem; }
    .arrow { width: 1.2rem; }
</style>


// WEBPACK FOOTER //
// src/components/article/View.vue